// extracted by mini-css-extract-plugin
export var container = "_ne-0";
export var dotAnimation = "_ne-2";
export var dotsLoading = "_ne-1";